// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2idFy","topBottomGutter":"Layout_topBottomGutter__24YOl"};